import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

const todayStringDE = () => {
  const dayjsToday = dayjs()
  return dayjsToday.format('DD.MM.YYYY')
}

export default todayStringDE
